import React, { useMemo, useState } from "react";
import EmployeeCountExport from "core/Operations/employeeCountExport";
import { DatePicker, Table, Select } from "antd";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import { useTableSearch } from "core/Operations/useTableSearch";
import Error404 from "MainPages/ErrorPages/error404";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { PlusCircle, Search, Upload } from "react-feather";
import { Link } from "react-router-dom";
import { all_routes } from "Router/all_routes";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import TableTop from "Components/UI/TableTop";
import PropTypes from "prop-types";
import { useEmployeeCount } from "AppQuries/report/get-employee-count-report";
import useTableExport from "core/Operations/useTableExport";
import { useGetEmployeeWorkTypesQuery } from "AppQuries/master/employee-work-type";
import { useGetEmployeeStatusesQuery } from "AppQuries/master/employee-status";
import { BackIcon } from "Components/UI/Icon/Icons";
const { RangePicker } = DatePicker;

const EmployeeCountReport = () => {
  const userData = useSelector(loggedInUser);
  const [status, setStatus] = useState("");
  const {
    data: employeeCount = {},
    isLoading,
    isError,
    error,
    refetch: refetchEmployeeCount,
  } = useEmployeeCount({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
    isAllCompanies: userData?.isAllCompanies,
    selectedCompanyCode: userData?.selectedCompanyCode,
    userId: userData?.userID,
    status: status,
  });

  const { data: employeeStatues } = useGetEmployeeStatusesQuery({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
  });

  const mainColumns = [
    { title: "Department", dataIndex: "department", key: "department" },
    { title: "Location", dataIndex: "location", key: "location" },
    { title: "Employee Count", dataIndex: "count", key: "count" },
  ];

  const allTablesData = [
    // {
    //   sheetName: "Main Report",
    //   columns: mainColumns,
    //   data: employeeCount || [],
    // },
    {
      sheetName: "Work Type Count",
      columns: generateRoleColumns(),
      data: employeeCount?.EmployeeWorkTypeCounts || [],
    },
    {
      sheetName: "Local Employee Count",
      columns: generateRoleColumns(),
      data: employeeCount?.LocalEmployeeCounts || [],
    },
    {
      sheetName: "Foreign Employee Count",
      columns: generateRoleColumns(),
      data: employeeCount?.ForeignEmployeeCounts || [],
    },
    {
      sheetName: "Pass Type Count",
      columns: generatePassTypeColumns(),
      data: employeeCount?.EmployeePassTypeCounts || [],
    },
  ];

  if (isLoading) return <LoadingSpinner />;
  if (isError) return <Error404 isError={isError} error={error} />;

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Employee Count Report</h4>
              {/* <h6>Generate man hour project report</h6> */}
            </div>
          </div>

          <div className="page-btn">
            <EmployeeCountExport
              tables={allTablesData}
              fileName="All Employee Reports"
              buttonText="Export All to Excel"
              buttonIcon={<Upload className="me-2" />}
              className="btn btn-primary me-2"
            />
          </div>

          <div className="page-btn">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
            >
              <Link to={all_routes.report_list} className="btn btn-secondary">
                
                <BackIcon className="me-2" />
                Back
              </Link>
            </OverlayTrigger>
          </div>
        </div>

        <div className="employee-count p-3">
          <div className="card border-0">
            <div className="card-body">
              <div className="row">
                <div className="col-9">
                  <h4 className="header-title">Status</h4>
                  <div className="d-flex align-items-center justify-content-start ">
                    {employeeStatues?.map((item) => (
                      <div
                        className="form-check form-check-md d-flex align-items-center"
                        key={item.statusCode}
                      >
                        <input
                          name="employeeStatus"
                          className="form-check-input"
                          type="radio"
                          value={item.statusName}
                          id={item.statusCode}
                          checked={status === item.statusCode}
                          onChange={() => setStatus(item.statusCode)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={item.statusCode}
                        >
                          {item.statusName}
                        </label>
                        &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;
                      </div>
                    ))}
                  </div>
                </div>
                <div className="col-3">
                  <div
                    className="d-flex align-items-center justify-content-end "
                    style={{
                      position: "relative",
                      top: "25px",
                    }}
                  >
                    <button
                      className="btn btn-primary"
                      onClick={refetchEmployeeCount}
                    >
                      <Search className="me-2" />
                      Filter
                    </button>
                    <label className="form-check-label">{""}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <>
            <div className="mb-3">
              {/* <h5>Total Employees: {employeeCount?.totalCount || 0}</h5> */}
            </div>

            {/* <ReportSection
              title="Employee Count"
              dataSource={employeeCount}
              columns={mainColumns}
              fileName="Main Employee Count"
            /> */}

            <ReportSection
              title="Employee Count by Work Type"
              dataSource={employeeCount?.EmployeeWorkTypeCounts}
              columns={generateRoleColumns()}
              fileName="Work Type Count"
            />
            <ReportSection
              title="Local Employee Count"
              dataSource={employeeCount?.LocalEmployeeCounts}
              columns={generateRoleColumns()}
              fileName="Local Employee Count"
            />
            <ReportSection
              title="Foreign Employee Count"
              dataSource={employeeCount?.ForeignEmployeeCounts}
              columns={generateRoleColumns()}
              fileName="Foreign Employee Count"
            />
            <ReportSection
              title="Employee Count by Pass Type"
              dataSource={employeeCount?.EmployeePassTypeCounts}
              columns={generatePassTypeColumns()}
              fileName="Pass Type Count"
            />
          </>
        </div>
      </div>
    </div>
  );
};

const ReportSection = ({ title, dataSource = [], columns, fileName }) => {
  if (
    (!Array.isArray(dataSource) || dataSource.length === 0) &&
    typeof dataSource !== "object"
  )
    return null;

  return (
    <div className="mt-5">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h5>{title}</h5>
        {/* <EmployeeCountExport
          columns={columns}
          data={dataSource}
          fileName={fileName}
          buttonText="Export"
          buttonIcon={<Download size={14} className="me-1" />}
          className="btn btn-outline-primary btn-sm"
        /> */}
      </div>
      <Table
        columns={columns}
        dataSource={Array.isArray(dataSource) ? dataSource : [dataSource]}
        rowKey={(record, index) => `${record.CompanyName || "row"}-${index}`}
        pagination={false}
      />
    </div>
  );
};

ReportSection.propTypes = {
  title: PropTypes.string.isRequired,
  dataSource: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  columns: PropTypes.array.isRequired,
  fileName: PropTypes.string.isRequired,
};

const generateRoleColumns = () => [
  { title: "Company Name", dataIndex: "CompanyName", key: "CompanyName" },
  { title: "Management", dataIndex: "Management", key: "Management" },
  { title: "Staff", dataIndex: "Staff", key: "Staff" },
  { title: "Test", dataIndex: "Test", key: "Test" },
  { title: "Worker", dataIndex: "Worker", key: "Worker" },
  { title: "Total", dataIndex: "Total", key: "Total" },
];

const generatePassTypeColumns = () => [
  { title: "Company Name", dataIndex: "CompanyName", key: "CompanyName" },
  { title: "Business Visa", dataIndex: "Business Visa", key: "Business Visa" },
  { title: "Citizen", dataIndex: "Citizen", key: "Citizen" },
  {
    title: "Employment Pass",
    dataIndex: "Employment Pass",
    key: "Employment Pass",
  },
  { title: "PEP", dataIndex: "PEP", key: "PEP" },
  {
    title: "Permanent Residents",
    dataIndex: "Permanent Residents",
    key: "Permanent Residents",
  },
  { title: "S Pass", dataIndex: "S Pass", key: "S Pass" },
  {
    title: "SG Work Permit",
    dataIndex: "SG Work Permit",
    key: "SG Work Permit",
  },
  { title: "Student Pass", dataIndex: "Student Pass", key: "Student Pass" },
  { title: "TEP", dataIndex: "TEP", key: "TEP" },
  { title: "Work Permit", dataIndex: "Work Permit", key: "Work Permit" },
  { title: "Total", dataIndex: "Total", key: "Total" },
];

export default EmployeeCountReport;

// const EmployeeCountReport = () => {
//   const userData = useSelector(loggedInUser);
//   const [status, setStatus] = useState("");

//   const {
//     refetch: refetchEmployeeCount,
//     data: employeeCount = {},
//     isLoading,
//     isError,
//   } = useEmployeeCount({
//     companyCode: userData?.companyCode,
//     locationCode: userData?.locationCode,
//     status: status,
//   });

//   const { data: employeeStatues } = useGetEmployeeStatusesQuery({
//     companyCode: userData?.companyCode,
//     locationCode: userData?.locationCode,
//   });

//   console.log("workingStatus", employeeStatues);

//   const mainColumns = [
//     { title: "Department", dataIndex: "department", key: "department" },
//     { title: "Location", dataIndex: "location", key: "location" },
//     { title: "Employee Count", dataIndex: "count", key: "count" },
//   ];

//   const { onEmployeeCountDownload } = useTableExport({
//     columns: mainColumns.map(({ title, dataIndex }) => ({ title, dataIndex })),
//     data: [employeeCount] || [],
//     fileName: "Employee Count Report",
//   });

//   return (
//     <div className="page-wrapper">
//       <div className="content">
//         <div className="page-header">
//           <div className="add-item d-flex">
//             <div className="page-title">
//               <h4>Employee Count Report</h4>
//               {/* <h6></h6> */}
//             </div>
//           </div>
//           <div className="page-btn">
//             <button
//               className="btn btn-primary"
//               onClick={onEmployeeCountDownload}
//             >
//               <Upload className="me-2" />
//               Export to Excel
//             </button>
//           </div>
//         </div>
//         <div className="employee-count p-3">
//           {isLoading ? (
//             <p>Loading employee count...</p>
//           ) : isError ? (
//             <p>Error fetching employee count</p>
//           ) : (
//             <>
//               {/* <TableTop
//                 title={`Total Employees: ${employeeCount?.totalCount || 0}`}
//                 onSearch={() => {}}
//                 rightContent={

//                 }
//               /> */}

//               <div className="card border-0">
//                 <div className="card-body">
//                   <div className="row">
//                     <div className="col-9">
//                       <h4 className="header-title">Status</h4>
//                       <div className="d-flex align-items-center justify-content-start ">
//                         {employeeStatues?.map((item) => (
//                           <div
//                             className="form-check form-check-md d-flex align-items-center"
//                             key={item.statusCode}
//                           >
//                             <input
//                               name="employeeStatus"
//                               className="form-check-input"
//                               type="radio"
//                               value={item.statusName}
//                               id={item.statusCode}
//                               checked={status === item.statusCode}
//                               onChange={() => setStatus(item.statusCode)}
//                             />
//                             <label
//                               className="form-check-label"
//                               htmlFor={item.statusCode}
//                             >
//                               {item.statusName}
//                             </label>
//                             &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                     <div className="col-3">
//                       <div
//                         className="d-flex align-items-center justify-content-end "
//                         style={{
//                           position: "relative",
//                           top: "25px",
//                         }}
//                       >
//                         <button
//                           className="btn btn-primary"
//                           onClick={refetchEmployeeCount}
//                         >
//                           <Search className="me-2" />
//                           Filter
//                         </button>
//                         <label className="form-check-label">{""}</label>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               {/* <Table columns={mainColumns} data={employeeCount || []} /> */}

//               <ReportSection
//                 title="Employee Count by Work Type"
//                 dataSource={employeeCount?.EmployeeWorkTypeCounts}
//                 columns={generateRoleColumns()}
//               />
//               <ReportSection
//                 title="Local Employee Count"
//                 dataSource={employeeCount?.LocalEmployeeCounts}
//                 columns={generateRoleColumns()}
//               />
//               <ReportSection
//                 title="Foreign Employee Count"
//                 dataSource={employeeCount?.ForeignEmployeeCounts}
//                 columns={generateRoleColumns()}
//               />
//               <ReportSection
//                 title="Employee Count by Pass Type"
//                 dataSource={employeeCount?.EmployeePassTypeCounts}
//                 columns={generatePassTypeColumns()}
//               />
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// const ReportSection = ({ title, dataSource = [], columns }) => {
//   if (!Array.isArray(dataSource) || dataSource.length === 0) return null;

//   return (
//     <div className="mt-5">
//       <h5 className="mb-2">{title}</h5>
//       <Table
//         columns={columns}
//         dataSource={dataSource}
//         rowKey={(record, index) => `${record.CompanyName || "row"}-${index}`}
//         pagination={false}
//       />
//     </div>
//   );
// };

// ReportSection.propTypes = {
//   title: PropTypes.string.isRequired,
//   dataSource: PropTypes.array,
//   columns: PropTypes.array.isRequired,
// };

// const generateRoleColumns = () => [
//   { title: "Company Name", dataIndex: "CompanyName", key: "CompanyName" },
//   { title: "Management", dataIndex: "Management", key: "Management" },
//   { title: "Staff", dataIndex: "Staff", key: "Staff" },
//   { title: "Test", dataIndex: "Test", key: "Test" },
//   { title: "Worker", dataIndex: "Worker", key: "Worker" },
//   { title: "Total", dataIndex: "Total", key: "Total" },
// ];

// const generatePassTypeColumns = () => [
//   { title: "Company Name", dataIndex: "CompanyName", key: "CompanyName" },
//   { title: "Business Visa", dataIndex: "Business Visa", key: "Business Visa" },
//   { title: "Citizen", dataIndex: "Citizen", key: "Citizen" },
//   {
//     title: "Employment Pass",
//     dataIndex: "Employment Pass",
//     key: "Employment Pass",
//   },
//   { title: "PEP", dataIndex: "PEP", key: "PEP" },
//   {
//     title: "Permanent Residents",
//     dataIndex: "Permanent Residents",
//     key: "Permanent Residents",
//   },
//   { title: "S Pass", dataIndex: "S Pass", key: "S Pass" },
//   {
//     title: "SG Work Permit",
//     dataIndex: "SG Work Permit",
//     key: "SG Work Permit",
//   },
//   { title: "Student Pass", dataIndex: "Student Pass", key: "Student Pass" },
//   { title: "TEP", dataIndex: "TEP", key: "TEP" },
//   { title: "Work Permit", dataIndex: "Work Permit", key: "Work Permit" },
//   { title: "Total", dataIndex: "Total", key: "Total" },
// ];

// TableTop.propTypes = {
//   onSearch: PropTypes.func.isRequired,
//   title: PropTypes.string,
//   rightContent: PropTypes.node,
// };

// export default EmployeeCountReport;
